import { gql } from '@apollo/client';

export const TAG_COUNT_FRAGMENT = gql`
  fragment TagCount on Tag {
    count
  }
`;

export const TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT = gql`
  fragment TagHighlightWithTag on TagHighlight {
    id
    charStart
    charEnd
    tag {
      id
      name
      tagType
      ...TagCount
      tagGroup {
        id
        color
      }
    }
  }
  ${TAG_COUNT_FRAGMENT}
`;

export const GET_TAGS_BY_COMPANY_ID = gql`
  query Tags($companyId: ID!) {
    tags(companyId: $companyId) {
      id
      name
      count
      description
      tagType
      tagGroup {
        id
      }
    }
    tagGroups(companyId: $companyId) {
      id
      name
      description
      color
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CreateTag($name: String!, $description: String, $tagGroupId: ID, $companyId: ID!){
    createTag(name: $name, description: $description, tagGroupId: $tagGroupId, companyId: $companyId){
      tag {
        id
        name
        count
        tagType
        description
        tagGroup {
          id
          name
          description
          color
        }
        createdBy{
          id
        }
      }
    }
  }
`;

export const CREATE_MERGED_TAG = gql`
  mutation CreateMergedTag($name: String!, $tagGroupId: ID, $companyId: ID!, $tagIds: [ID!]!){
    createMergedTag(name: $name, tagGroupId: $tagGroupId, companyId: $companyId, tagIds: $tagIds){
      tag {
        id
        name
        count
        tagType
        description
        tagGroup {
          id
          name
          description
          color
        }
        createdBy{
          id
        }
      }
    }
  }
`;

export const UPDATE_TAG = gql`
  mutation UpdateTag($id: ID!, $attributes: TagAttributes!) {
    updateTag(id: $id, attributes: $attributes) {
      tag {
        id
        name
        count
        tagType
        description
        tagGroup {
          id
          name
          description
          color
          company {
            id
            name
          }
        }
        createdBy{
          id
        }
      }
    }
  }
`;

export const CREATE_TAG_GROUP = gql`
  mutation CreateTagGroup($name: String!, $description: String, $color: String!, $companyId: ID!){
    createTagGroup(name: $name, description: $description, color: $color, companyId: $companyId){
      tagGroup {
        id
        name
        description
        color
      }
    }
  }
`;

export const CREATE_MERGED_TAG_GROUP = gql`
  mutation CreateMergedTagGroup($name: String!, $description: String, $color: String!, $companyId: ID!, $tagGroupIds: [ID!]!){
    createMergedTagGroup(name: $name, description: $description, color: $color, companyId: $companyId, tagGroupIds: $tagGroupIds){
      tagGroup {
        id
        name
        description
        color
      }
    }
  }
`;

export const UPDATE_TAG_GROUP = gql`
  mutation UpdateTagGroup($id: ID!, $attributes: TagGroupAttributes!) {
    updateTagGroup(id: $id, attributes: $attributes) {
      tagGroup {
        id
        name
        description
        color
        company {
          id
        }
      }
    }
  }
`;

export const DELETE_TAG_GROUP = gql`
  mutation DeleteTagGroup($id: ID!) {
        deleteTagGroup(id: $id) {
          void
        }
      }
`;

export const DELETE_TAG = gql`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id) {
      void
    }
  }
`;

export const CREATE_TAG_HIGHLIGHT = gql`
  mutation CreateTagHighlight($tagHighlights: [TagHighlightAttributes!]!){
    createTagHighlight(tagHighlights: $tagHighlights){
      tagHighlights {
        ...TagHighlightWithTag
      }
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const updateCacheOnCreateTag = (companyId) => (cache, { data }) => {
  const { createTag: { tag } } = data;
  const variables = { companyId };
  const { tags: cachedTags } = cache.readQuery({
    query: GET_TAGS_BY_COMPANY_ID,
    variables,
  });
  const tags = [...cachedTags, tag];
  cache.writeQuery({
    query: GET_TAGS_BY_COMPANY_ID,
    variables,
    data: { tags },
  });
};

export const updateCacheOnCreateTagGroup = (companyId) => (cache, { data }) => {
  const { createTagGroup: { tagGroup } } = data;
  const variables = { companyId };
  const { tagGroups: cachedTagGroups } = cache.readQuery({
    query: GET_TAGS_BY_COMPANY_ID,
    variables,
  });
  const tagGroups = [...cachedTagGroups, tagGroup];
  cache.writeQuery({
    query: GET_TAGS_BY_COMPANY_ID,
    variables,
    data: { tagGroups },
  });
};
